import React from 'react'
import Modal from '../../modals/wrapper'
import useClientLocation from '../../../hooks/use-client-location'
import useCourse from '../../../hooks/use-course'
import { get } from 'lodash'
import UserCourseCalendar from '../../user/course-calendar'
import useCurrentUser from '../../../hooks/use-current-user'
import moment from 'moment'
import { Dot, ArrowRightShort } from 'react-bootstrap-icons'
import useCourseSeries from './use-course-series'
import HourLabel from '../../hours/label'
import DurationLabel from '../../durations/label'

const EmptyDayMessage = () => {
    return (
        <div className='text-center text-muted'>
            There is nothing scheduled for this day.
        </div>
    )
}

const ScheduleItem = ({
    experience = {}
}) => {
    const Icon = experience.preview ? ArrowRightShort : Dot
    return (
        <div style={{ display: 'flex', alignItems: 'flex-start'}}>
            <div><Icon size={20} /></div>
            <div>
                <div style={{ flex: '1', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}>{experience.name}</div>
                <div className='text-muted'>
                    <HourLabel hourId={experience.hourId} /> - <DurationLabel durationId={experience.durationId} />

                </div>
            </div>
        </div>
    )
}


const SchedulePreview = () => {
    const { goBack, params } = useClientLocation()
    const experienceId = get(params, 'experienceId')
    const { course: experience, isBusy: isLoading, isEnrolled } = useCourse({ id: experienceId })
    const { series, isLoadingSeries } = useCourseSeries({ seriesId: experience.seriesId })
    const { id: userId } = useCurrentUser()
    const [ dateSelected, setDateSelected ] = React.useState(moment(experience.date))
    const previewCourses = (experience.seriesId ? get(series, 'courses', []) : [experience]).map(e => ({ ...e, preview: true }))

    return (
        <Modal
            closeButton
            onHide={goBack}
            closeStyle={{ color: 'white' }}
        >
            <div style={{ minHeight: '300px'}}>
                <div
                    style={{
                        backgroundColor: 'rgb(0, 105, 217)',
                        height: '130px',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'flex-end',
                        padding: '40px',
                        paddingBottom: '5px',
                    }}
                >
                    <div style={{ color: 'white', fontSize: '1.2em' }}>
                        <strong>{experience.name}</strong>
                    </div>
                </div>
                <div style={{ padding: '40px'}}>
                    <UserCourseCalendar
                        date={dateSelected}
                        userId={userId}
                        previewExperiences={previewCourses}
                        itemComponent={ScheduleItem}
                        onDateChange={setDateSelected}
                        emptyDayMessage={(<EmptyDayMessage />)}
                    />
                </div>
            </div>
        </Modal>
    )
}

export default SchedulePreview